import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { Session, User } from "@supabase/supabase-js";

type AuthCtx = { user: User | null; session: Session | null; loading: boolean };
const Ctx = createContext<AuthCtx>({ user: null, session: null, loading: true });

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [session, setSession] = useState<Session | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkBan = async (s: Session | null) => {
      if (!s?.user) return;
      const { data, error } = await supabase.from("profiles").select("banned,banned_reason").eq("id", s.user.id).maybeSingle();
      if (error || !data) return; // tolerate missing profile / transient errors during signup
      if (data.banned) {
        await supabase.auth.signOut();
        setSession(null); setUser(null);
        alert("تم حظر حسابك. السبب: " + (data.banned_reason ?? "غير محدد"));
      }
    };
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s);
      setUser(s?.user ?? null);
      setTimeout(() => checkBan(s), 0);
    });
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
      checkBan(session);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  return <Ctx.Provider value={{ user, session, loading }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
